/**
 * Utility to format large numbers into human-readable strings (e.g., 1.6k, 3.2m).
 * @param num The number to format
 * @returns A formatted string
 */
export const formatCount = (num: number): string => {
  if (num === undefined || num === null || isNaN(num)) return '0';
  
  if (num >= 1000000) {
    const formatted = (num / 1000000).toFixed(1);
    return formatted.endsWith('.0') ? `${Math.floor(num / 1000000)}m` : `${formatted}m`;
  }
  
  if (num >= 1000) {
    const formatted = (num / 1000).toFixed(1);
    return formatted.endsWith('.0') ? `${Math.floor(num / 1000)}k` : `${formatted}k`;
  }
  
  return num.toString();
};
